import {
	useState,
	useMemo,
	SetStateAction,
	Dispatch
} from 'react';
import "./SummaryPage.css";

//Components
import SummaryTable from './summary-table/SummaryTable';
import Carousel from '../../shared/carousel/Carousel';
import { Property } from '../../../models/Property';
import PDFGen from './pdf-gen/PDFGen';
import { Header, GeneralInformation, MapSection } from './summary-page-components';
import PDFListView from './pdf-viewer/PDFListView';

interface SummaryPageProps {
	map: React.MutableRefObject<__esri.WebMap>;
	setProperty: (val: Property | undefined) => void;
	property: Property;
	extent: __esri.Extent;
	setSearchParams: Function;
}

export default function SummaryPage({ property, setProperty, map, extent, setSearchParams }: SummaryPageProps) {
	const [showImageModal, setShowImageModal] = useState(false);
	const [showDocumentModal, setShowDocumentModal] = useState(false);
	const [showBrochure, setShowBrochure] = useState(false);

	const summaryContent = useMemo(() => {
		let className = 'summary--content';
		if (!property.site && property.building) {
			className += '__building';
		} else if (property.site && !property.building) {
			className += '__site';
		}

		return className;
	}, [property]);

	return (
		<>
			<Modals
				property={property}
				showDocumentModal={showDocumentModal}
				setShowDocumentModal={setShowDocumentModal}
				showBrochure={showBrochure}
				setShowBrochure={setShowBrochure}
				showImageModal={showImageModal}
				setShowImageModal={setShowImageModal}
			/>

			<div className='summary-page--container'>
				<Header
					property={property}
					setProperty={setProperty}
					showDocumentModal={showDocumentModal}
					setShowDocumentModal={setShowDocumentModal}
					showBrochure={showBrochure}
					setShowBrochure={setShowBrochure}
					setSearchParams={setSearchParams}
				/>
				<div className="summary-page--main-content-container">
					<div className={summaryContent}>
						<GeneralInformation 
							property={property} 
							setShowImageModal={setShowImageModal}
						/>
						<section className='summary-section'>
							{property && <SummaryTable property={property} />}
						</section>
						
						<MapSection
							property={property}
							extent={extent}
							map={map}
						/>
					</div>
				</div>
			</div>
		</>
	);
}

interface ModalsProps {
	property: Property;
	showDocumentModal: boolean;
	setShowDocumentModal: Dispatch<SetStateAction<boolean>>;
	showBrochure: boolean;
	setShowBrochure: Dispatch<SetStateAction<boolean>>;
	showImageModal: boolean;
	setShowImageModal: Dispatch<SetStateAction<boolean>>;
}

function Modals({
	property,
	showDocumentModal,
	setShowDocumentModal,
	showBrochure,
	setShowBrochure,
	showImageModal,
	setShowImageModal
}: ModalsProps) {
	const [src, setSrc] = useState<string>(property.brochureUrl);

	return (
		<>
			<PDFGen
				showmodal={showDocumentModal}
				property={property}
				setShowModal={setShowDocumentModal} />
			<PDFListView
				showDocumentModal={showBrochure}
				setShowDocumentModal={setShowBrochure}
				src={src}
				setSrc={setSrc}
				property={property}
			/>
			<Carousel
				showImageModal={showImageModal}
				setShowImageModal={setShowImageModal}
				imageUrl={property.images}
			/>
		</>
	);
}